<template>
  <UiInputDateRangePickerVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'

type DateRange = [Date | null, Date | null]

export default {
  name: 'UiInputDateRangePickerVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    modelValue: {
      type: Array as unknown as PropType<DateRange>,
      required: true as const,
    },
    locale: { type: String as PropType<'da' | 'en'>, default: undefined },
    dateFormat: {
      type: [String, Function] as PropType<string | ((date: Date) => string)>,
      default: undefined,
    },
    minDate: { type: Object as PropType<Date>, default: undefined },
    maxDate: { type: Object as PropType<Date>, default: undefined },
    placeholder: { type: String, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
  },
}
</script>

